import { v4 as uuidv4 } from 'uuid';
import { CustomExposureConfig } from './types';

const DEFAULT_CATEGORY = 'Custom';
const DEFAULT_NAME = 'Custom exposure';

export const buildDefaultCustomExposureConfig = (entityType: number): CustomExposureConfig => ({
    id: `${uuidv4()}_custom_rule`,
    name: DEFAULT_NAME,
    displayName: DEFAULT_NAME,
    category: DEFAULT_CATEGORY,
    description: '',
    isActive: true,
    entityType,
    usersAndGroups: [],
    conditions: [],
    excludedUsersAndGroups: [],
    excludedConditions: [],
    isStatic: false
});